import { CircularProgress } from '@mui/material';
import React from 'react';
import { GridContainer } from 'shared/components/ui/grid-container';

import * as Styled from './loading-search-overview.style';

export const LoadingSearchOverview: React.FC = () => (
  <Styled.Container>
    <GridContainer>
      <CircularProgress />
    </GridContainer>
  </Styled.Container>
);
